import axios, { AxiosRequestConfig } from 'axios';
import createApp from '@shopify/app-bridge';
import { getSessionToken } from '@shopify/app-bridge-utils';

import { getAppConfig, getShop } from './misc';


axios.defaults.headers.post = {
  'Content-Type': 'application/json',
};

const axiosInstance = axios.create({
  baseURL: process.env.CONFIGURATION_PUBLIC_ADDRESS,
});

const appConfig = getAppConfig();

if (appConfig) {
  const app = createApp(appConfig);

  axiosInstance.interceptors.request.use(function (config: AxiosRequestConfig) {
    return getSessionToken(app)
      // TODO: consider to implement token error handling
      .then((token) => {
        const configHeaders = config?.headers || {};
        const configParams = config?.params || {};
        if (config.url?.includes('/v2/')) { // 
          config.params = { ...configParams };
        } else {
          config.params = { ...configParams, shop: getShop(token) };
        }        
        configHeaders['Authorization'] = `Bearer ${token}`;
        return config;
      });
  });
}

export default axiosInstance;
